import { useViewport } from '@tryhackme/thm-ui-components';
import { useMemo } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
const SUPPORTED_ROOMS = new Set(['offensivesecurityintro', 'offensivesecurityintrokK']);
export const useShouldSeeStartVmExpand = (roomCode: string, activeAccordion: number | null) => {
  const {
    width
  } = useViewport();
  const taskStates = useAppSelector(state => state.room.taskStates);
  const hasTaskBeenCompleted = useMemo(() => {
    if (!activeAccordion || activeAccordion < 1) {
      return false;
    }
    const accordionTasks = taskStates[activeAccordion - 1];
    return accordionTasks?.every(taskState => taskState) ?? false;
  }, [activeAccordion, taskStates]);
  if (!activeAccordion || width < BREAKPOINTS.MOBILE) return false;
  if (activeAccordion !== 2 || !SUPPORTED_ROOMS.has(roomCode)) {
    return false;
  }
  return !hasTaskBeenCompleted;
};